import { Typography } from "antd";

import { StyledDetail } from "components/job/index/jobInformationRow";
import LabelSkeleton from "lib/loader/job/index/labelSkeleton";

const { Text } = Typography;

const LabelAndValue = (props) => {
  const { status, label, value, mt2 } = props;

  return (
    <StyledDetail $mt2={mt2}>
      <Text className="title">{label}</Text>
      {status !== "success" || status === "loading" ? (
        <LabelSkeleton />
      ) : (
        <Text className="value">{value}</Text>
      )}
    </StyledDetail>
  );
};

export default LabelAndValue;
